import React from "react";
import { Box, Text } from "@chakra-ui/react";

export type StatusBadgeColorVariant =
  | "white"
  | "red"
  | "redFilled"
  | "blueFilled"
  | "yellow"
  | "green"
  | "blue"
  | "gray";

export type StatusBadgeSizeVariant = "small" | "medium";

interface Props {
  status: string;
  colorVariant?: StatusBadgeColorVariant;
  size?: StatusBadgeSizeVariant;
}

const colorVariantMap = {
  white: {
    background: "#FCFCFB",
    border: "#8F8F8C",
    color: "#444444",
  },
  red: {
    background: "#FFEEEE",
    border: "#EE7D7A",
    color: "#444444",
  },
  // 강조가 필요한 배지용 — 배경을 채우고 글씨를 흰색으로 반전한다.
  redFilled: {
    background: "#CC1D1D",
    border: "#CC1D1D",
    color: "#FFFFFF",
  },
  // 강조가 필요한 긍정 배지용 — 배경을 채우고 글씨를 흰색으로 반전한다.
  blueFilled: {
    background: "#1272EF",
    border: "#1272EF",
    color: "#FFFFFF",
  },
  yellow: {
    background: "#FFF7CC",
    border: "#FFD600",
    color: "#444444",
  },
  green: {
    background: "#F0FAEF",
    border: "#16B41C",
    color: "#444444",
  },
  blue: {
    background: "#F0F9FF",
    border: "#48B5FE",
    color: "#444444",
  },
  gray: {
    background: "#EFEFED",
    border: "#8F8F8C",
    color: "#444444",
  },
};

function StatusBadge({
  status,
  colorVariant = "white",
  size = "medium",
}: Props) {
  const isSmall = size === "small";

  return (
    <Box
      borderRadius={"2px"}
      border={`1px solid ${colorVariantMap[colorVariant].border}`}
      background={colorVariantMap[colorVariant].background}
      padding={isSmall ? "1px 6px" : "0px 8px"}
      width={"fit-content"}
      whiteSpace={"nowrap"}
    >
      <Text
        textStyle={isSmall ? "caption-bold" : "body-sm-bold"}
        color={colorVariantMap[colorVariant].color}
      >
        {status}
      </Text>
    </Box>
  );
}

export default StatusBadge;
